import type { CoberturaDetalle, CotizaTodasResponse } from '@/types/quote.types';

const COVERAGE_DETAILS: Record<string, string> = {
  'DAÑOS MATERIALES': 'Te cubre los daños que pueda tener tu vehículo por colisión.',
  'ROBO TOTAL': 'Te cubre el robo de la unidad.',
  'RESPONSABILIDAD CIVIL': 'Cubre los daños que puedas causar a un tercero.',
  'GASTOS MÉDICOS OCUPANTES': 'Cubre los gastos médicos de los ocupantes del vehículo.',
  'MUERTE DEL CONDUCTOR  X AA': 'Cubre la muerte accidental del conductor.',
  'ASISTENCIA LEGAL': 'Proporciona asistencia legal en caso de accidente.',
  'ASISTENCIA VIAL': 'Proporciona asistencia vial en caso de emergencia.',
};

export const normalizeCoverageToken = (value: string): string =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

export const getCoberturaKey = (cobertura: CoberturaDetalle): string =>
  `${cobertura.Id_Cobertura}-${normalizeCoverageToken(cobertura.Nombre)}`;

const getCoberturaQualityScore = (cobertura: CoberturaDetalle): number => {
  const deducible = normalizeCoverageToken(cobertura.Deducible);
  const sumaAsegurada = normalizeCoverageToken(cobertura.SumaAsegurada);
  const hasExcludedToken = /(excluid|na$|n\/a)/.test(`${deducible} ${sumaAsegurada}`);
  return hasExcludedToken ? 0 : 1;
};

const dedupeCoberturas = (coberturas: CoberturaDetalle[]): CoberturaDetalle[] => {
  const deduped = new Map<string, CoberturaDetalle>();

  for (const cobertura of coberturas) {
    const key = getCoberturaKey(cobertura);
    const existing = deduped.get(key);
    if (!existing || getCoberturaQualityScore(cobertura) > getCoberturaQualityScore(existing)) {
      deduped.set(key, cobertura);
    }
  }

  return Array.from(deduped.values());
};

export function buildCoberturasPorPlan(source: CotizaTodasResponse | null): CoberturaDetalle[] {
  if (!source?.Cobertura?.Coberturas) return [];

  const amparadas = source.Cobertura.Coberturas.filter((c) => c.EstaAmparada);
  return dedupeCoberturas(amparadas).sort((a, b) => {
    if (a.Id_Cobertura === b.Id_Cobertura) return a.Nombre.localeCompare(b.Nombre, 'es-MX');
    return a.Id_Cobertura - b.Id_Cobertura;
  });
}

export const getCoberturaDetalle = (nombre: string): string =>
  COVERAGE_DETAILS[nombre.toUpperCase()] || 'Cobertura incluida en tu póliza.';
